import { render, staticRenderFns } from "./ViewIncident.vue?vue&type=template&id=0a5bb1eb&"
import script from "./ViewIncident.vue?vue&type=script&lang=js&"
export * from "./ViewIncident.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports